<template>

<div class="template" v-if="getTemplateData">
	<div class="left-sidebar template-builder-sidebar">
		<div class="template-options-sections" v-if="!selectedSidebar">
			<div class="overlay" v-if="selectedSection"></div>
			<div class="accordion template-options">
				<div class="accordion-header" :class="{ 'selected': selectedAccordion == 'template-options' }" @click="toggleAccordion('template-options')">Template</div>
				<div class="accordion-content" v-if="selectedAccordion == 'template-options'">
					<ul>
						<li @click="selectedSidebar = 'full-width'">Full Width</li>
						<li @click="selectedSidebar = 'colors'">Colors</li>
						<li @click="selectedSection = 'fonts'">Fonts</li>
						<li @click="selectedSidebar = 'site_background'">Background</li>
						<li @click="selectedSidebar = 'meta'">News</li>
						<li @click="selectedSidebar = 'page_nav'">Page Menu</li>
						<li @click="selectedSidebar = 'main_nav'">Product Menu</li>
						<li @click="selectedSidebar = 'footer'">Footer</li>
					</ul>
				</div>
			</div>
			<div class="accordion section-list">
				<div class="accordion-header" :class="{ 'selected': selectedAccordion == 'section-list' }" @click="toggleAccordion('section-list')">Sections</div>
				<draggable class="accordion-content" v-if="selectedAccordion == 'section-list'" :list="filteredAvailableSections" :group="{ name: 'available_sections', pull: 'clone', put: false }" :clone="cloneSection" :sort="false" @start="drag = true" @end="drag = false">
					<component v-bind:is="element.name" :compact="true" class="draggable" v-for="(element, index) in filteredAvailableSections" :key="index"></component>
				</draggable>
			</div>
			<div class="accordion section-list">
				<div class="pointer" @click="selectedSection = 'product'">Edit Product Tile Layout</div>
			</div>
		</div>

		<!-- Full Width -->
		<div class="template-options-sections" v-if="selectedSidebar == 'full-width'">
			<h3>Full Width</h3>
			<div class="control-group">
				<label class="dark-font radio first">
					<input type="radio" v-model="getTemplateData.siteOptions.fullWidth" :value="1">
					<span class="show"><i class="fas fa-check-circle"></i>On</span>
				</label>
				<label class="dark-font radio last">
					<input type="radio" v-model="getTemplateData.siteOptions.fullWidth" :value="0">
					<span class="hide"><i class="fas fa-check-circle"></i>Off</span>
				</label>
			</div>
			<p class="small">With full width on, the content areas of your website will fill the width of the visitor’s browser.</p>
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save Width</span></div>
				<div class="button action" @click="saveTemplateData(template_id)" v-else>
					<span>
						<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
						Save Width
					</span>
				</div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSidebar = null">Back</div>
				<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
			</div>
		</div>

		<!-- Colors -->
		<div class="template-options-sections" v-if="selectedSidebar == 'colors'">
			<!-- <div class="back-button" @click="selectedSidebar = null"><i class="fas fa-caret-left"></i> Back</div> -->
			<h3>Color Schemes</h3>

			<ul>
				<li class="color-scheme" :class="{ selected: getTemplateData.siteOptions.colorScheme == index }" v-for="(colorScheme, index) in getStyleOptions.colorSchemes" @click="updateColorScheme(index)" :key="index">
					<ul>
						<li v-for="(color, index) in colorScheme" :key="index" :style="{ 'background-color': 'rgba(' + color + ')' }"></li>
					</ul>
				</li>
			</ul>
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save Colors</span></div>
				<div class="button action" @click="saveTemplateData(template_id)" v-else>
					<span>
						<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
						Save Colors
					</span>
				</div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSidebar = null">Back</div>
				<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
			</div>
		</div>

		<!-- Background -->
		<div class="template-options-sections" v-if="selectedSidebar == 'site_background'">
			<div class="back-button" @click="selectedSidebar = null"><i class="fas fa-caret-left"></i> Back</div>
			<h3>Site Background</h3>

			<h4>Color</h4>
			<color-picker :colors="getColorSchemeColors" :selected="(getTemplateData.siteOptions.backgroundColor.value !== null) ? getTemplateData.siteOptions.backgroundColor.value : getTemplateData.siteOptions.backgroundColor.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.backgroundColor.value', value: $event })"></color-picker>

			<h4>Image</h4>
			<div class="image-thumb" v-if="getTemplateData.siteOptions.backgroundImage.image_src">
				<img class="background-image-thumb" :src="getTemplateData.siteOptions.backgroundImage.image_src">
				<div class="remove-link pointer" @click="removeImage({ path: 'siteOptions.backgroundImage', image_id: getTemplateData.siteOptions.backgroundImage.image_id })">Remove</div>
			</div>
			<vue-dropzone @vdropzone-success="siteBackgroundUploadSuccess" @vdropzone-error="siteBackgroundUploadError" ref="siteBackgroundDropzone" id="site_background_dropzone" :options="siteBackgroundDropzoneOptions" v-else></vue-dropzone>
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save Background</span></div>
				<div class="button action" @click="saveTemplateData(template_id)" v-else>
					<span>
						<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
						Save Background
					</span>
				</div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSidebar = null">Back</div>
				<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
			</div>
		</div>

		<!-- Meta -->
		<div class="template-options-sections" v-if="selectedSidebar == 'meta'">
			<div class="back-button" @click="selectedSidebar = null"><i class="fas fa-caret-left"></i> Back</div>
			<h3>News</h3>
			<a href="/dashboard/website/news-alerts" target="_blank" class="website-link">Add News Alerts</a>
			<div class="control-group">
				<label class="dark-font radio first">
					<input type="radio" v-model="getTemplateData.siteOptions.meta.showing" :value="1">
					<span class="show"><i class="fas fa-check-circle"></i>Show</span>
				</label>
				<label class="dark-font radio last">
					<input type="radio" v-model="getTemplateData.siteOptions.meta.showing" :value="0">
					<span class="hide"><i class="fas fa-check-circle"></i>Hide</span>
				</label>
			</div>

			<h4>Text Color</h4>
			<color-picker :colors="getColorSchemeFontColors" :selected="(getTemplateData.siteOptions.meta.color.value !== null) ? getTemplateData.siteOptions.meta.color.value : getTemplateData.siteOptions.meta.color.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.meta.color.value', value: $event })"></color-picker>

			<h4>Background Color</h4>
			<color-picker :colors="getColorSchemeColors" :selected="(getTemplateData.siteOptions.meta.backgroundColor.value !== null) ? getTemplateData.siteOptions.meta.backgroundColor.value : getTemplateData.siteOptions.meta.backgroundColor.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.meta.backgroundColor.value', value: $event })"></color-picker>
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save News</span></div>
				<div class="button action" @click="saveTemplateData(template_id)" v-else>
					<span>
						<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
						Save News
					</span>
				</div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSidebar = null">Back</div>
				<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
			</div>
		</div>

		<!-- Page Nav -->
		<div class="template-options-sections" v-if="selectedSidebar == 'page_nav'">
			<div class="back-button" @click="selectedSidebar = null"><i class="fas fa-caret-left"></i> Back</div>
			<h3>Page Menu</h3>
			<a href="/dashboard/website/menus" target="_blank" class="website-link">Add Menu Links</a>
			<div class="control-group">
				<label class="dark-font radio first">
					<input type="radio" v-model="getTemplateData.siteOptions.navPage.showing" :value="1">
					<span class="show"><i class="fas fa-check-circle"></i>Show</span>
				</label>
				<label class="dark-font radio last">
					<input type="radio" v-model="getTemplateData.siteOptions.navPage.showing" :value="0">
					<span class="hide"><i class="fas fa-check-circle"></i>Hide</span>
				</label>
			</div>

			<h4>Alignment</h4>
			<select @change="updateTemplateData({ path: 'siteOptions.navPage.alignmentClass', value: $event.target.value })">
				<option value="left" :selected="getTemplateData.siteOptions.navPage.alignmentClass == 'left'">Left</option>
				<option value="center" :selected="getTemplateData.siteOptions.navPage.alignmentClass == 'center'">Center</option>
				<option value="right" :selected="getTemplateData.siteOptions.navPage.alignmentClass == 'right'">Right</option>
			</select>

			<h4>Font Size</h4>
			<select @change="updateTemplateData({ path: 'siteOptions.navPage.fontSize', value: $event.target.value })">
				<option value="0.9rem" :selected="getTemplateData.siteOptions.navPage.fontSize == '0.9rem'">Smaller</option>
				<option :value="null" :selected="getTemplateData.siteOptions.navPage.fontSize == ''">Default</option>
				<option value="1.2rem" :selected="getTemplateData.siteOptions.navPage.fontSize == '1.2rem'">Larger</option>
			</select>

			<h4>Text Color</h4>
			<color-picker :colors="getColorSchemeFontColors" :selected="(getTemplateData.siteOptions.navPage.color.value !== null) ? getTemplateData.siteOptions.navPage.color.value : getTemplateData.siteOptions.navPage.color.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.navPage.color.value', value: $event })"></color-picker>

			<h4>Background Color</h4>
			<color-picker :colors="getColorSchemeColors" :selected="(getTemplateData.siteOptions.navPage.backgroundColor.value !== null) ? getTemplateData.siteOptions.navPage.backgroundColor.value : getTemplateData.siteOptions.navPage.backgroundColor.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.navPage.backgroundColor.value', value: $event })"></color-picker>
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save Menu</span></div>
				<div class="button action" @click="saveTemplateData(template_id)" v-else>
					<span>
						<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
						Save Menu
					</span>
				</div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSidebar = null">Back</div>
				<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
			</div>
		</div>

		<!-- Main Nav -->
		<div class="template-options-sections" v-if="selectedSidebar == 'main_nav'">
			<div class="back-button" @click="selectedSidebar = null"><i class="fas fa-caret-left"></i> Back</div>
			<h3>Product Menu</h3>
			<a href="/dashboard/website/menus" target="_blank" class="website-link">Add Menu Links</a>
			<h4>Alignment</h4>
			<select @change="updateTemplateData({ path: 'siteOptions.navMain.alignmentClass', value: $event.target.value })">
				<option value="left" :selected="getTemplateData.siteOptions.navMain.alignmentClass == 'left'">Left</option>
				<option value="center" :selected="getTemplateData.siteOptions.navMain.alignmentClass == 'center'">Center</option>
				<option value="right" :selected="getTemplateData.siteOptions.navMain.alignmentClass == 'right'">Right</option>
			</select>

			<h4>Font Size</h4>
			<select @change="updateTemplateData({ path: 'siteOptions.navMain.fontSize', value: $event.target.value })">
				<option value="0.9rem" :selected="getTemplateData.siteOptions.navMain.fontSize == '0.9rem'">Smaller</option>
				<option :value="null" :selected="getTemplateData.siteOptions.navMain.fontSize == ''">Default</option>
				<option value="1.2rem" :selected="getTemplateData.siteOptions.navMain.fontSize == '1.2rem'">Larger</option>
			</select>

			<h4>Text Color</h4>
			<color-picker :colors="getColorSchemeFontColors" :selected="(getTemplateData.siteOptions.navMain.color.value !== null) ? getTemplateData.siteOptions.navMain.color.value : getTemplateData.siteOptions.navMain.color.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.navMain.color.value', value: $event })"></color-picker>

			<h4>Background Color</h4>
			<color-picker :colors="getColorSchemeColors" :selected="(getTemplateData.siteOptions.navMain.backgroundColor.value !== null) ? getTemplateData.siteOptions.navMain.backgroundColor.value : getTemplateData.siteOptions.navMain.backgroundColor.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.navMain.backgroundColor.value', value: $event })"></color-picker>
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save Menu</span></div>
				<div class="button action" @click="saveTemplateData(template_id)" v-else>
					<span>
						<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
						Save Menu
					</span>
				</div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSidebar = null">Back</div>
				<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
			</div>
		</div>

		<!-- Footer -->
		<div class="template-options-sections" v-if="selectedSidebar == 'footer'">
			<div class="back-button" @click="selectedSidebar = null"><i class="fas fa-caret-left"></i> Back</div>
			<h3>Footer</h3>
			<a href="/dashboard/website/menus" target="_blank" class="website-link">Add Menu Links</a>
			<h4>Text Color</h4>
			<color-picker :colors="getColorSchemeFontColors" :selected="(getTemplateData.siteOptions.footer.color.value !== null) ? getTemplateData.siteOptions.footer.color.value : getTemplateData.siteOptions.footer.color.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.footer.color.value', value: $event })"></color-picker>

			<h4>Background Color</h4>
			<color-picker :colors="getColorSchemeColors" :selected="(getTemplateData.siteOptions.footer.backgroundColor.value !== null) ? getTemplateData.siteOptions.footer.backgroundColor.value : getTemplateData.siteOptions.footer.backgroundColor.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.footer.backgroundColor.value', value: $event })"></color-picker>
			<div class="controls template-controls">
				<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save Menu</span></div>
				<div class="button action" @click="saveTemplateData(template_id)" v-else>
					<span>
						<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
						Save Menu
					</span>
				</div>
				<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSidebar = null">Back</div>
				<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
			</div>
		</div>

		<div class="divider"></div>

		<div class="controls template-controls">
			<div class="button neutral" @click="preview">Preview</div>
			<div class="button primary publish" @click="publish">
				<div class="spinner" v-if="publishing || publishSuccess">
					<i class="fas fa-spinner fa-spin" v-if="publishing"></i>
					<transition name="fade">
						<i class="fas fa-check" v-if="publishSuccess"></i>
					</transition>
				</div>
				<span>Publish</span>
			</div>
			<div>Ready to publish your website template? Make sure you <a href="/dashboard/help-center/articles/359" target="_blank" class="website-link">Add Content</a> to your website too!</div><br>
			<router-link tag="button" to="/website/template-manager" class="button neutral"><span>Exit Template Builder</span></router-link>
		</div>

		<div class="divider"></div>

		<div class="controls template-controls">

		<div class="template-description">
			<div class="accordion-header">Template Name</div>
			<input type="text" v-model="templateDescription">
			<div :class="['button', saving ? 'disabled' : 'primary']" @click="saveTemplateDescription()">Save Name</div>
		</div>

	</div>
	</div>

	<div ref="main_content" class="main-content template-content">

		<div id="website-preview" :class="[ selectedDevice, (landscapeMode) ? 'landscape' : null ]">
			<!-- Fonts -->
			<transition name="expand">
				<div class="section-edit fonts" v-if="selectedSection == 'fonts'">
					<div class="controls template-controls">
						<div class="button disabled" v-if="!getTemplateDataChanged"><span>Save Fonts</span></div>
						<div class="button action" @click="saveTemplateData(template_id)" v-else>
							<span>
								<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
								Save Fonts
							</span>
						</div>
						<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSection = null">Back</div>
						<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
					</div>

					<h1>Fonts</h1>
                    <h2>Heading Font</h2>
                    <div class="columns columns-3 font-families">
    					<div class="font-family" :class="{ selected: index == getTemplateData.siteOptions.highlightFont }" v-for="(highlightFont, index) in getStyleOptions.highlightFonts" :key="highlightFont.label" @click="updateTemplateData({ path: 'siteOptions.highlightFont', value: index })">
    						<h1 :style="{ fontFamily: highlightFont.value }">{{ highlightFont.label }}</h1>
    					</div>
                    </div>
                    <h2>Body Font</h2>
                    <div class="columns columns-3 font-families">
                        <div class="font-family" :class="{ selected: index == getTemplateData.siteOptions.bodyFont }" v-for="(bodyFont, index) in getStyleOptions.bodyFonts" :key="bodyFont.label" @click="updateTemplateData({ path: 'siteOptions.bodyFont', value: index })">
    						<p :style="{ fontFamily: bodyFont.value }">{{ bodyFont.label }}</p>
    					</div>
                    </div>
					<h2>Font Color</h2>
					<div class="font-color">
						<color-picker :colors="getColorSchemeFontColors" :selected="(getTemplateData.siteOptions.bodyFontColor.value !== '') ? getTemplateData.siteOptions.bodyFontColor.value : getTemplateData.siteOptions.bodyFontColor.defaultColor" @colorClick="updateTemplateData({ path: 'siteOptions.bodyFontColor.value', value: $event })"></color-picker>
						<span class="note">NOTE: font color only applies to content pages, product detail, my account and other pages.<br>It does not affect your menus or other home page sections.</span>
					</div>
				</div>
			</transition>

			<div ref="meta" class="section meta" v-if="getTemplateData.siteOptions.meta.showing && !selectedSection">
				<ul class="news-ticker">
					<li>Some extra special news goes here!</li>
				</ul>
			</div>

			<!-- Desktop -->
			<nav ref="page_nav" class="section desktop-page-menu" :class="[ getTemplateData.siteOptions.navPage.alignmentClass, sectionsClass ]" v-if="!selectedSection && getTemplateData.siteOptions.navPage.showing">
				<div class="content">
					<ul class="menu">
						<li>Page 1</li>
						<li>Page 2</li>
						<li>Page 3</li>
						<li>Page 4</li>
						<li>Page 5</li>
					</ul>
				</div>
			</nav>

			<transition name="slide-in">
		        <div class="mobile-menu-inner" v-if="mobileDropdownOpen && !selectedSection">
		            <div class="button close" @click="mobileDropdownOpen = null"><i class="fas fa-times"></i></div>
		            <nav class="page-menu" v-if="getTemplateData.headerOptions.navPage.showing">
		                <ul>
							<li>Page 1</li>
							<li>Page 2</li>
							<li>Page 3</li>
							<li>Page 4</li>
							<li>Page 5</li>
		                </ul>
		            </nav>
		            <nav class="section" role="main">
		                <div class="content">
		                    <ul>
		                        <li>Long Guns</li>
		                        <li>Handguns</li>
		                        <li>Accessories</li>
		                        <li>Shop All Brands</li>
		                    </ul>
		                </div>
		            </nav>
		        </div>
		    </transition>
		    <!-- slide-down -->

			<header ref="header" class="section" :class="[ getTemplateData.headerOptions.layout, sectionsClass ]" v-if="!selectedSection || selectedSection == 'header'">
				<div class="content">
					<!-- Mobile -->
					<div :class="['hamburger', { open: mobileDropdownOpen == true }]" @click="mobileDropdownOpen = !mobileDropdownOpen">
		                <div class="layer layer-1"></div>
		                <div class="layer layer-2"></div>
		                <div class="layer layer-3"></div>
		            </div>
					<div id="logo-container">
		                <a href="#" @click="selectSection('header')">
							<img :src="getTemplateData.headerOptions.logo.image_src" class="logo" v-if="getTemplateData.siteOptions && getTemplateData.headerOptions.logo.image_src">
		                    <h1 v-else>{{ getClient.company_name }}</h1>
		                </a>
		            </div>
		            <div class="shopping-cart-icon">
		                <a href="#">My Account</a>
		                <span class="cart-icon" v-if="getTemplateData.siteOptions">
		                    <i class="fas fa-shopping-cart"></i>
		                    <div class="cart-count">2</div>
		                </span>
		            </div>
		            <div class="search">
		                <span class="input-go"><i class="fas fa-search"></i></span>
		                <input type="text">
		            </div>
				</div>

				<div class="section-controls" v-if="!selectedSection">
					<div class="button edit" @click="selectSection('header')">Edit <i class="fas fa-pen"></i></div>
				</div>
			</header>

			<!-- <transition-expand> -->
			<transition name="expand">
				<div class="section-edit three-columns" v-if="selectedSection == 'header'">
					<h3 class="span-all">Layout</h3>
					<div class="layout-option pointer" :class="{ selected: getTemplateData.headerOptions.layout == 'logo-left' }" @click="updateHeaderOptions({ prop: 'layout', value: 'logo-left' })"><img src="@/assets/img/HeaderLayoutL.jpg" alt=""></div>
					<div class="layout-option pointer" :class="{ selected: getTemplateData.headerOptions.layout == 'logo-center' }" @click="updateHeaderOptions({ prop: 'layout', value: 'logo-center' })"><img src="@/assets/img/HeaderLayoutC.jpg" alt=""></div>
					<div class="layout-option pointer" :class="{ selected: getTemplateData.headerOptions.layout == 'logo-right' }" @click="updateHeaderOptions({ prop: 'layout', value: 'logo-right' })"><img src="@/assets/img/HeaderLayoutR.jpg" alt=""></div>

					<h3>Logo</h3>
					<h3>Background Image</h3>
					<h3>Background Image Position</h3>

					<!-- Logo -->
					<div class="image-thumb" v-if="getTemplateData.headerOptions.logo.image_src">
						<img class="background-image-thumb" :src="getTemplateData.headerOptions.logo.image_src">
						<div class="remove-link pointer" @click="removeImage({ path: 'headerOptions.logo', image_id: getTemplateData.headerOptions.logo.image_id })">Remove</div>
					</div>
					<vue-dropzone @vdropzone-success="logoUploadSuccess" ref="logoDropzone" id="logo_dropzone" :options="logoDropzoneOptions" v-else></vue-dropzone>

					<!-- Background Image -->
					<div class="image-thumb" v-if="getTemplateData.headerOptions.backgroundImage.image_src">
						<img class="background-image-thumb" :src="getTemplateData.headerOptions.backgroundImage.image_src">
						<div class="remove-link pointer" @click="removeImage({ path: 'headerOptions.backgroundImage', image_id: getTemplateData.headerOptions.backgroundImage.image_id })">Remove</div>
					</div>
					<vue-dropzone @vdropzone-success="headerBackgroundUploadSuccess" ref="headerBackgroundDropzone" id="header_background_dropzone" :options="headerBackgroundDropzoneOptions" v-else></vue-dropzone>

					<!-- Background Image Position -->
					<div class="range-groups" :class="{ disabled: !getTemplateData.headerOptions.backgroundImage.image_src }">
						<div class="range-group">
							<label>Left</label>
							<input :disabled="!getTemplateData.headerOptions.backgroundImage.image_src" type="range" min="-200" max="200" v-model="headerBackgroundPositionX">
							<label>Right</label>
						</div>
						<div class="range-group">
							<label>Up</label>
							<input :disabled="!getTemplateData.headerOptions.backgroundImage.image_src" type="range" min="-400" max="400" v-model="headerBackgroundPositionY">
							<label>Down</label>
						</div>
						<div class="range-group">
							<label>100%</label>
							<input :disabled="!getTemplateData.headerOptions.backgroundImage.image_src" type="range" min="100" max="400" v-model="headerBackgroundSize">
							<label>400%</label>
						</div>
					</div>

					<h3>Colors</h3>
					<h3></h3>
					<h3></h3>


					<!-- Colors -->
					<ul class="header-color-options">
						<li class="color-option">
							<label>Background</label>
							<color-picker :colors="getColorSchemeColors" :selected="(getTemplateData.headerOptions.backgroundColor.value !== null) ? getTemplateData.headerOptions.backgroundColor.value : getTemplateData.headerOptions.backgroundColor.defaultColor" @colorClick="updateTemplateData({ path: 'headerOptions.backgroundColor.value', value: $event })"></color-picker>
						</li>
						<li class="color-option">
							<label>Cart</label>
							<color-picker :colors="getColorSchemeFontColors" :selected="(getTemplateData.headerOptions.shoppingCart.color.value !== null) ? getTemplateData.headerOptions.shoppingCart.color.value : getTemplateData.headerOptions.shoppingCart.color.defaultColor" @colorClick="updateTemplateData({ path: 'headerOptions.shoppingCart.color.value', value: $event })"></color-picker>
						</li>
						<li class="color-option">
							<label>Item Count Icon</label>
							<color-picker :colors="getColorSchemeCountIconColors" :selected="(getTemplateData.headerOptions.shoppingCartCount.color.value !== null) ? getTemplateData.headerOptions.shoppingCartCount.color.value : getTemplateData.headerOptions.shoppingCartCount.color.defaultColor" @colorClick="updateTemplateData({ path: 'headerOptions.shoppingCartCount.color.value', value: $event })"></color-picker>
						</li>
					</ul>

					<div></div>
					<div></div>

					<div class="controls template-controls">
						<div class="button disabled" v-if="!getTemplateDataChanged"><span><i class="fas fa-check"></i> Save</span></div>
						<div class="button action" @click="saveTemplateData(template_id)" v-else>
							<span>
								<i class="fas fa-check" v-if="!getSaving"></i>
								<i class="fas fa-spinner fa-spin" v-if="getSaving"></i>
								Save
							</span>
						</div>
						<div class="button cancel" v-if="!getTemplateDataChanged" @click="selectedSection = null">Back</div>
						<div class="button cancel" @click="revertTemplateData" v-else>Cancel</div>
					</div>
				</div>
			</transition>
			<!-- </transition-expand> -->

			<!-- Mobile -->
			<transition name="slide-down">
				<!-- <div class="mobile-menu section" :class="[ { 'open': mobileDropdownOpen } ]"> -->
				<div class="mobile-menu section" v-if="mobileDropdownOpen">
					<nav class="page-menu" v-if="getTemplateData.headerOptions.nav.selected">
						<ul>
							<li>About</li>
							<li>Policies</li>
						</ul>
					</nav>
					<nav class="section" role="main">
						<div class="content">
							<ul>
								<li>Category 1</li>
								<li>Department 2</li>
								<li>Product Group 3</li>
								<li>Shop All Brands</li>
							</ul>
						</div>
					</nav>
				</div>
			</transition>
			<!-- slide-down -->

			<!-- Desktop -->
			<nav ref="main_nav" class="section desktop-nav" :class="[ getTemplateData.siteOptions.navMain.alignmentClass, sectionsClass ]" role="main" v-if="!selectedSection">
				<div class="content">
					<ul class="menu">
						<li>Category 1</li>
						<li>Department 2</li>
						<li>Product Group 3</li>
						<li>Shop All Brands</li>
					</ul>
				</div>
			</nav>

			<transition name="expand">
				<product :editing="true" :product="sampleProduct" :config="{ template_id: template_id }" v-on:update:selectedSection="selectedSection = $event" v-if="selectedSection == 'product'" @deSelectSection="selectedSection = null"></product>
			</transition>

			<draggable class="sections" :class="sectionsClass" v-model="pageSections" v-bind="pageSectionsOptions" @start="drag = true" @end="drag = false" @change="endDrag">
				<component
					v-bind:is="element.name"
					:compact="false"
					:config="{ template_id: template_id, selectedSection: selectedSection, index: index + 1, drag: drag, noedit: element.name == 'marquee', nolink: element.name == 'custom-content', hash: element.hash }"
					:options="element.options"
					@selectSection="selectedSection = index + 1"
					@deSelectSection="selectedSection = null"
					@removeSection="removeSection(index)"
					:class="['section', { draggable: !selectedSection, marquee: element.name == 'marquee' }]"
					v-for="(element, index) in pageSections" :key="index"
					v-if="!selectedSection || selectedSection == index + 1"></component>
			</draggable>

			<footer ref="footer" class="section columns columns-3" v-if="!selectedSection || selectedSection == 'footer'">
				<!-- Footer menu part 1 -->
				<div class="column">
					<ul class="desktop-footer-menu menu">
						<li>Page 1</li>
						<li>Page 2</li>
						<li>Page 3</li>
					</ul>
				</div>

				<!-- Footer menu part deux -->
				<div class="column">
					<ul class="desktop-footer-menu menu">
						<li><a href="#" to="/logbooks/termsofuse">Terms of Use</a></li>
						<li><a href="#" to="/logbooks/datacenter">Data Center</a></li>
						<li v-if="getUser.user_name"><a href="#" to="/logbooks/customersupport">Customer Support</a></li>
					</ul>
				</div>

				<div class="column">
					<i class="fab fa-facebook-square"></i>
					<i class="fab fa-twitter-square"></i>
					<div class="copyright">
						&copy; {{ $moment().format('YYYY') }} Connected Data Solutions
					</div>
				</div>
			</footer>
		</div>
	</div>

	<help-popup :helpLink="{95:'Customizing Your Template', 96:'Template Width', 97:'Color Schemes', 98:'Fonts', 99:'Site Background', 100:'Customizing News Alerts', 101:'Page Menu and Product Menu', 102:'Footer Menu', 103:'Home Page Sections', 104:'Header', 105:'Marquees', 106:'Featured Collections and Best Sellers', 107:'Featured Products Section', 108:'Department Links Section', 109:'Custom Content Sections', 110:'Edit Product Tile Layout', 111:'Preview and Publish a Template'}" :tours="false"></help-popup>

</div>

<loading class="main template full-page" v-else></loading>

</template>

<script>
var template_styles = document.getElementById('template_styles');
if (!template_styles) {
    template_styles = document.createElement('style');
    template_styles.id = "template_styles";
    document.head.appendChild(template_styles);
}
import { mapGetters, mapActions } from 'vuex'
import CustomContent from '../components/CustomContent'
import DepartmentLinks from '../components/DepartmentLinks'
import FeaturedCollections from '../components/FeaturedCollections'
import FeaturedProductRow from '../components/FeaturedProductRow'
import Marquee from '../components/Marquee'
import Product from '../components/Product'
import SuggestedItemDepartments from '../components/SuggestedItemDepartments'
import ColorPicker from '../components/ColorPicker'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: '',
    props: ['template_id'],
    components: {
        'custom-content': CustomContent,
        'department-links': DepartmentLinks,
        'featured-collections': FeaturedCollections,
        'featured-product-row': FeaturedProductRow,
        'marquee': Marquee,
        'product': Product,
        'suggested-item-departments': SuggestedItemDepartments,
        'color-picker': ColorPicker,
        'vue-dropzone': vue2Dropzone,
		'help-popup': HelpPopup
    },
	data() {
		return {
			pageSectionsLoaded: false,
			loading: false,
			saving: false,
			publishing: false,
			publishSuccess: false,
      templateDataId: null,
			templateDescription: '',
			selectedDevice: 'desktop',
			landscapeMode: false,
			selectedAccordion: null,
			selectedOptions: [],
			selectedSection: null,
			selectedSidebar: null,
			mobileDropdownOpen: false,
			map: {
				'black': 'dark',
				'gold': 'dark',
				'red': 'america',
				'green': 'green',
				'blue': 'blue',
				'brown': 'brown',
				'orange': 'dark'
			},
			availableSections: [
				{
					name: "marquee",
					options: {
						title: 'Marquees',
						custom: false,
						link: "",
						image: {
							image_id: null,
							image_src: "@/assets/img/marquee-banner-slug.jpg"
						}
					}
				},
				{
					name: "featured-collections",
					options: {
						title: 'Featured Collections',
						// rows: 1,
						columns: 3
					}
				},
				{
					name: "featured-product-row",
					options: {
						title: 'Featured Products',
						style: {}
					}
				},
				{
					name: "department-links",
					options: {
						imageStyle: (this.getTemplateData) ? this.map[this.getTemplateData.siteOptions.colorScheme] : 'dark',
						columns: 3,
						// rows: 1,
						department: {
							'font-size': { value: null, default: "2.2vw" },
							"color": { value: 0, defaultColor: 0 },
						}
					}
				},
				{
					name: "suggested-item-departments",
					options: {
						title: 'Best Sellers',
						columns: 3,
						// rows: 1
					}
				},
				{
					name: "custom-content",
					options: {
						styles: {},
						backgroundImage: {
							image_src: '',
							image_id: ''
						},
						sectionHeight: 360,
						textDivShow: 1,
						textDivOpacity: 5,
						textDivBackgroundColor: {
							value: '',
							defaultColor: 2
						},
						textDivWidthClass: 'two-thirds',
						textDivAlignmentClass: 'right',
						color: {
							value: '',
							defaultColor: 1
						},
						content: '<h1>Lorem ipsum</h1><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maiores natus libero, omnis accusantium quam voluptates perspiciatis veritatis quos porro. Vero quo, fugiat porro dolorem corporis aliquid tempora quaerat eos itaque?</p>'
					}
				}
			],
			drag: false,
			backgroundImageHeight: 0,
			backgroundImageWidth: 0,
			headerWidth: 0,
			headerHeight: 0,
			headerBackgroundImageWidth: 0,
			headerBackgroundImageHeight: 0,
			stylesheet: null,
			footerOptions: {},
            sampleProduct: {
				title: "Product Name",
				product_id: "34402-2",
				upc: "123456789012",
				price: "300.99",
				image_url: 'https://media.shootingsportsmedia.com/templates/productsample-1.jpg'
			},
			navMain: [],
			navPage: [],
		}
	},
	created() {
        // this.loading = true
		this.getSiteTemplateData(this.template_id)
		this.siteOptionsStyle()

		var styleSheet = document.getElementById("template_styles").sheet
		var styles = ""
		_.forOwn(styleSheet.rules, (rule, index) => {
			styles += rule.cssText.replace('.website', '#website-preview') + "\n"
		})

		this.$store.subscribe((mutation, state) => {
			switch(mutation.type) {
				case 'website_module/COPY_TEMPLATE_DATA':
                    this.loading = false
					this.selectedSection = null
					this.selectedSidebar = null
					break;
				case 'website_module/REVERT_TEMPLATE_DATA':
					this.selectedSection = null
					this.selectedSidebar = null
				case 'website_module/UPDATE_COLOR_SCHEME':
					this.resetTemplateColors();
				case 'website_module/UPDATE_TEMPLATE_DATA':
                    this.loading = false
					if (mutation.payload
						&& mutation.payload.path
						&& mutation.payload.path.indexOf('content') > -1
						&& mutation.payload.path.indexOf('Image') == -1
						&& mutation.payload.path.indexOf('image') == -1
						&& mutation.payload.path.indexOf('logo') == -1){
							break;
						}
				case 'website_module/REMOVE_IMAGE':
				case 'website_module/UPDATE_PAGE_SECTION_OPTION':
				case 'website_module/UPDATE_HEADER_OPTIONS':
				case 'website_module/UPDATE_PRODUCT_SECTIONS':
				case 'website_module/UPDATE_PRODUCT_SECTIONS_STYLES':
				case 'website_module/UPDATE_PRODUCT_SECTIONS_STYLE':
					this.siteOptionsStyle()
					break;
			}
		})
	},
	watch: {
		selectedSidebar(value) {
			switch(value) {
				case 'meta':
					if (!this.getTemplateData.siteOptions.meta.showing) { break }
				case 'page_nav':
					if (!this.getTemplateData.siteOptions.navPage.showing) { break }
				case 'main_nav':
				case 'footer':
					//console.log(this.$refs)
					window.scrollTo({
						top: this.$refs[value].offsetTop - 150,
						left: 0,
						behavior: 'smooth'
					})
					break;
				default:
					// Nothing
					break;
			}
		}
	},
	computed: {
        ...mapGetters('website_module', [
            'getTemplateData',
            'getTemplateDataChanged',
            'getStyleOptions',
            'getColorSchemeColors',
            'getColorSchemeFontColors',
            'getColorSchemeCountIconColors',
            'getHeaderOptions',
            'getSaving'
        ]),
		filteredAvailableSections() {
			return this.availableSections.filter(section => {
				var i = 0, present = false
				while(i < this.pageSections.length) {
					if (section.name != 'custom-content') {
						if (section.name == this.pageSections[i].name) {
							present = true
							break
						}
					}
					i++
				}
				return !present
			})
		},
		pageSections: {
			get() {
				return this.getTemplateData.pageSections || []
			},
			set(value) {
				this.$store.commit('website_module/UPDATE_TEMPLATE_DATA', ({ path: 'pageSections', value: value }))
			}
		},
		sectionsClass() {
			if (!this.getTemplateData.siteOptions) return

			return [
				(this.getTemplateData.siteOptions.fullWidth) ? 'full-width' : ''
			]
		},
		headerBackgroundPositionX: {
			get() {
                if (!this.getTemplateData) return null
				return this.getTemplateData.headerOptions.backgroundPositionX
			},
			set(value) {
				this.updateTemplateData({ path: 'headerOptions.backgroundPositionX', value: value })
                this.siteOptionsStyle()
			}
		},
		headerBackgroundPositionY: {
			get() {
                if (!this.getTemplateData) return null
				return this.getTemplateData.headerOptions.backgroundPositionY
			},
			set(value) {
				this.updateTemplateData({ path: 'headerOptions.backgroundPositionY', value: value })
                this.siteOptionsStyle()
			}
		},
		headerBackgroundSize: {
			get() {
                if (!this.getTemplateData) return null
				return this.getTemplateData.headerOptions.backgroundSize
			},
			set(value) {
				this.updateTemplateData({ path: 'headerOptions.backgroundSize', value: value })
                this.siteOptionsStyle()
			}
		},
		pageSectionsOptions() {
			return {
				group: { name: 'page_sections', put: ['page_sections', 'available_sections'] },
				draggable: '.draggable',
				ghostClass: "sortable-ghost",
				chosenClass: "sortable-chosen",
				dragClass: "sortable-drag",
				handle: ".drag"
			}
		},
		siteOptionsBackgroundColor: {
			get() {
				return this.getTemplateData.siteOptions.backgroundColor
			},
			set(value) {
				this.updateTemplateData({ path: 'siteOptions.backgroundColor', value: value })
			}
		},
		headerOptionsStyle: {
			get() {
				return {
					backgroundColor: this.getHeaderOptions.backgroundColor,
					backgroundPositionX: this.getHeaderOptions.backgroundPositionX,
					backgroundPositionY: this.getHeaderOptions.backgroundPositionY,
					backgroundSize: this.getHeaderOptions.backgroundSize,
					fontFamily: this.getHeaderOptions.fontFamily,
					backgroundImage: this.getHeaderOptions.backgroundImage.image_src
				}
			},
			set(value) {
				this.updateTemplateData({ path: 'headerOptions', value: value })
			}
		},
		navStyle() {
			return [ 'header nav',
				[ 'position', 2 ],
				[ 'color', 'white' ]
			]
		},
		siteBackgroundDropzoneOptions() {
			return {
				acceptedFiles: 'image/jpeg, image/png',
				url: this.getImageUploadAPI,
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 1.0,
				addRemoveLinks: true,
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'WEBSITE',
					context: 'BACKGROUND',
					variation: 'large',
					image_id: this.getTemplateData.siteOptions.backgroundImage.image_id || '',
					template_data_id: this.getTemplateData.template_data_id || ''
				}
			}
		},
		logoDropzoneOptions() {
			return {
				acceptedFiles: 'image/jpeg, image/png',
				url: this.getImageUploadAPI,
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 1.0,
				addRemoveLinks: true,
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'WEBSITE',
					context: 'LOGO',
					variation: 'large',
					image_id: this.getTemplateData.headerOptions.logo.image_id || '',
					template_data_id: this.getTemplateData.template_data_id || ''
				}
			}
		},
		headerBackgroundDropzoneOptions() {
			return {
				acceptedFiles: 'image/jpeg, image/png',
				url: this.getImageUploadAPI,
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 1.0,
				addRemoveLinks: true,
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'WEBSITE',
					context: 'BACKGROUND',
					variation: 'large',
					image_id: this.getTemplateData.headerOptions.backgroundImage.image_id || '',
					template_data_id: this.getTemplateData.template_data_id || ''
				}
			}
		}
	},
	methods: {
        ...mapActions('website_module', [
            'updateTemplateData',
            'updateTemplateDataId',
            'updateHeaderOptions',
            'copyTemplateData',
            'addStylesheetRules',
            'saveTemplateData',
            'revertTemplateData',
            'removeImage',
            'updateColorScheme'
        ]),
		getSiteTemplateData() {
			var data = {
				template_id: this.template_id
			}
			this.apiCall({ destination: 'get_site_template_data', data }).then(obj => {
				if (obj.status == 'error') {
					// TO-DO: alert the user that the template couldn't be retrieved
				} else {
					this.templateDescription = obj.description
                    this.updateTemplateDataId(obj.template_data_id)
                    this.updateTemplateData({ path: null, value: obj.template_data })
                    this.copyTemplateData()
					this.siteOptionsStyle()
				}
			}).catch(error => {
				console.log(error)
				// TO-DO: alert the user that the options couldn't be retrieved
			})
		},
		saveTemplateDescription() {
			if (this.saving) { return }
			this.saving = true
			this.apiCall({ destination: 'save_item_template_description', data: { template_id: this.template_id, description: this.templateDescription } }).then(obj => {
				this.saving = false
				if (obj.status == 'error') {
					this.message = obj.message
				}
			}).catch(error => {
				console.log(error)
			})
		},
		preview() {
			this.saveTemplateData(this.template_id).then(() => {
				let previewURL
				if (window.location.hostname.indexOf('.test') > -1) {
					previewURL = 'https://cdsfrontend.test:8081/frontend/?template_id=' + this.template_id
				} else {
					previewURL = window.location.origin + '/' + "?template_id=" + this.template_id
				}
				var previewWindow = window.open(previewURL, "_blank")
			}).catch(err => {
				console.log(err)
			})
		},
		siteOptionsStyle() {
			if (!this.getTemplateData) return
			var highlightFont = this.getStyleOptions.highlightFonts[this.getTemplateData.siteOptions.highlightFont]
    		var bodyFont = this.getStyleOptions.bodyFonts[this.getTemplateData.siteOptions.bodyFont]
            var colorScheme = this.getStyleOptions.colorSchemes[this.getTemplateData.siteOptions.colorScheme]
    		var style = [],
    			index = 0
			style.push([ '@import',
				'url("https://fonts.googleapis.com/css?family='
					+ highlightFont.label.replace(' ', '+')
					+ '|'
					+ bodyFont.label.replace(' ', '+')
					+ '&display=swap")'
			])
			var backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.siteOptions.backgroundColor.value] !== null)
				? this.getColorSchemeColors[this.getTemplateData.siteOptions.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.siteOptions.backgroundColor.defaultColor]
			backgroundColor += ')'
			index++
			style.push([ '#website-preview', // "body" on the live site
				[ 'position', index ],
				[ 'font-family', bodyFont.value, true ],
				[ 'background-color', backgroundColor ],
				[ 'background-image', (this.getTemplateData.siteOptions.backgroundImage.image_src) ? 'url("' + this.getTemplateData.siteOptions.backgroundImage.image_src + '")' : null ]
			])
			var selectors = [ 'h1', 'h2', 'h3', 'h4', 'h5', 'h6' ]
			for (var i = 0; i < selectors.length; i++) {
				index++
				style.push([ selectors[i],
					[ 'position', index ],
					[ 'font-family', highlightFont.value ]
				])
			}
			var selectors = [ 'p', 'div', 'a', 'span', 'header', 'footer', 'div', 'ul', 'li', 'section', 'article', 'aside' ]
			for (var i = 0; i < selectors.length; i++) {
				index++
				style.push([ selectors[i],
					[ 'position', index ],
					[ 'font-family', bodyFont.value ]
				])
			}
			var bodyFontColor = (this.getTemplateData.siteOptions.bodyFontColor.value !== '') ? this.getTemplateData.siteOptions.bodyFontColor.value : this.getTemplateData.siteOptions.bodyFontColor.defaultColor
			backgroundColor = (bodyFontColor === 1) ? 1 : 2
			index++
			style.push([ '.main:not(.sections)',
				[ 'position', index ],
				[ 'background-color', 'rgba(' + this.getColorSchemeColors[backgroundColor] + ',0.5)' ],
				[ 'color', 'rgba(' + this.getColorSchemeFontColors[bodyFontColor] + ')' ]
			])
			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.siteOptions.meta.backgroundColor.value] != null)
				? this.getColorSchemeColors[this.getTemplateData.siteOptions.meta.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.siteOptions.meta.backgroundColor.defaultColor]
			backgroundColor += ')'
			index++
			style.push([ '.meta',
				[ 'position', index ],
				[ 'background-color', backgroundColor ]
			])
			var color = 'rgb('
			color += (this.getColorSchemeFontColors[this.getTemplateData.siteOptions.meta.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.siteOptions.meta.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.siteOptions.meta.color.defaultColor]
			color += ')'
			index++
			style.push([ '.meta li, .meta a',
				[ 'position', index ],
				[ 'color', color ],
                [ 'font-size', this.getTemplateData.siteOptions.meta.fontSize ]
			])
			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.siteOptions.navPage.backgroundColor.value] != null)
				? this.getColorSchemeColors[this.getTemplateData.siteOptions.navPage.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.siteOptions.navPage.backgroundColor.defaultColor]
			backgroundColor += ')'
			index++
			style.push([ 'nav.desktop-page-menu',
				[ 'position', index ],
				[ 'background-color', backgroundColor ]
			])
			color = 'rgb('
			color += (this.getColorSchemeFontColors[this.getTemplateData.siteOptions.navPage.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.siteOptions.navPage.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.siteOptions.navPage.color.defaultColor]
			color += ')'
			index++
			style.push([ 'nav.desktop-page-menu *',
				[ 'position', index ],
				[ 'color', color ],
                [ 'font-size', this.getTemplateData.siteOptions.navPage.fontSize ]
			])
			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.headerOptions.backgroundColor.value] != null)
				? this.getColorSchemeColors[this.getTemplateData.headerOptions.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.headerOptions.backgroundColor.defaultColor]
			backgroundColor += ')'
			index++
			style.push([ 'header',
				[ 'position', index ],
				[ 'background-color', backgroundColor ],
				[ 'background-position-x', this.getHeaderOptions.backgroundPositionX + "px" ],
				[ 'background-position-y', this.getHeaderOptions.backgroundPositionY + "px" ],
				[ 'background-size', this.getHeaderOptions.backgroundSize + "%" ],
				[ 'font-family', this.getHeaderOptions.fontFamily || bodyFont.value ],
				[ 'background-image', (this.getHeaderOptions.backgroundImage.image_src) ? 'url("' + this.getHeaderOptions.backgroundImage.image_src + '")' : null ]
			])
			color = 'rgb('
			color += (this.getColorSchemeFontColors[this.getTemplateData.headerOptions.shoppingCart.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.headerOptions.shoppingCart.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.headerOptions.shoppingCart.color.defaultColor]
			color += ')'
			index++
			style.push([ 'header .shopping-cart-icon, header i.fa-search, header h1',
				[ 'position', index ],
				[ 'color', color ]
			])
			var cartIconColor = this.getTemplateData.headerOptions.shoppingCart.color.value || 					this.getTemplateData.headerOptions.shoppingCart.color.defaultColor
			style.push([ 'header .shopping-cart-icon, header .shopping-cart-icon a, header h1',
			        [ 'position', index ],
			        [ 'color', color ]
			])

			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.headerOptions.shoppingCartCount.color.value])
				? this.getColorSchemeColors[this.getTemplateData.headerOptions.shoppingCartCount.color.value]
				: this.getColorSchemeColors[this.getTemplateData.headerOptions.shoppingCartCount.color.defaultColor]
			backgroundColor += ')'
			index++
			style.push([ 'header .cart-count', [ 'position', index ],
				[ 'color', color ],
				[ 'background-color', backgroundColor ]
			])
			// console.log(style)
			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeFontColors[this.getTemplateData.headerOptions.shoppingCart.color.value])
				? this.getColorSchemeFontColors[this.getTemplateData.headerOptions.shoppingCart.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.headerOptions.shoppingCart.color.defaultColor]
			backgroundColor += ')'
			index++
			style.push([ ".hamburger .layer",
				[ 'position', index ],
				[ 'background-color', backgroundColor ]
			])
			var navMainBackgroundColor = 'rgb('
			navMainBackgroundColor += (this.getColorSchemeColors[this.getTemplateData.siteOptions.navMain.backgroundColor.value])
				? this.getColorSchemeColors[this.getTemplateData.siteOptions.navMain.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.siteOptions.navMain.backgroundColor.defaultColor]
			navMainBackgroundColor += ')'
			index++
			style.push([ "nav[role='main']",
				[ 'position', index ],
				[ 'background-color', navMainBackgroundColor ]
			])
			var navMainColor = 'rgb('
			navMainColor += (this.getColorSchemeFontColors[this.getTemplateData.siteOptions.navMain.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.siteOptions.navMain.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.siteOptions.navMain.color.defaultColor]
			navMainColor += ')'
			index++
			style.push([ "nav[role='main'] *",
				[ 'position', index ],
				[ 'color', navMainColor ],
				[ 'font-size', this.getTemplateData.siteOptions.navMain.fontSize ]
			])
			index++
			style.push([ ".mobile-menu-inner, .mobile-menu-inner .page-menu",
				[ 'position', index ],
				[ 'background-color', navMainBackgroundColor ]
			])
			index++
			style.push([ ".mobile-menu-inner *",
				[ 'position', index ],
				[ 'color', navMainColor ]
			])
			index++
			style.push([ ".mobile-menu-inner .button.close",
				[ 'position', index ],
				[ 'color', navMainColor ]
			])
			_.forOwn(this.getTemplateData.pageSections, (section, localIndex) => {
				var sectionSelector = "." + section.name
                // if (section.options && section.options.styles && this.getTemplateData.styles[sectionSelector]) {
				if (section.options) {
					_.forOwn(section.options.styles, (rules, selector) => {
						// console.log(rules)
						index++
						var declarationBlock = [ selector, [ 'position', index ] ]
						_.forOwn(rules, (value, property) => {
							// console.log(value)
							if (typeof value == 'object') {
								var defaultValue = value.default
								var defaultColor = value.defaultColor
								value = value.value
							}
							// console.log(selector + ", " + property + ", " + defaultValue + ", " + defaultColor + ", " + value)
							if (value && value !== '') {
                                if (property.indexOf('color') > -1 && selector.indexOf('custom-content') == -1) {
									var color = 'rgba('
									color += (property == 'color') ? this.getColorSchemeFontColors[value] : this.getColorSchemeColors[value]
									color += ')'
                                    declarationBlock.push([ property, color ])
									// console.log(selector + ", " + property + ", " + "color value: ", color)
                                } else {
									// console.log(selector + ", " + property + ", " + "value: ", value)
    								declarationBlock.push([ property, value ])
                                }
							} else if (defaultColor !== undefined) {
								// console.log(selector + ", " + property + ", " + "defaultColor: ", defaultColor, this.getColorSchemeFontColors[defaultColor])
								var color = 'rgba('
								color += (property == 'color') ? this.getColorSchemeFontColors[defaultColor] : this.getColorSchemeColors[defaultColor]
								color += ')'
								declarationBlock.push([ property, color ])
							} else {
								// console.log(selector + ", " + property + ", " + "defaultValue: ", defaultValue)
								declarationBlock.push([ property, defaultValue ])
							}
						})
						// console.log(declarationBlock)
						style.push(declarationBlock)
					})
				}
			})
            index++
			var productBGTransparency = (this.getTemplateData.productSectionsStyles.transparent) ? 0 : 1
            var productBGColor =  "rgba("
			productBGColor += (this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.backgroundColor.value] != null)
				? this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.backgroundColor.defaultColor]
			productBGColor += `,${productBGTransparency})`
			color = 'rgb('
			color += (this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.color.defaultColor]
			color += ')'
            style.push([ '.product-container',
                [ 'position', index ],
                [ 'background-color', productBGColor ],
                [ 'color', color ]
            ])
            // console.log(style)
            index++
            var textAlign = (this.getTemplateData.productSectionsStyles.title.textAlign == 'center') ? 'center' : 'left'
            style.push([ '.product-container .product-title',
                [ 'position', index ],
                [ 'text-align', this.getTemplateData.productSectionsStyles.title.textAlign ],
                [ 'font-size', this.getTemplateData.productSectionsStyles.title.fontSize ]
            ])
            index++
            style.push([ '.product-container .product-price',
                [ 'position', index ],
                [ 'font-size', this.getTemplateData.productSectionsStyles.price.fontSize ]
            ])
            index++
            style.push([ '.product-container .product-meta',
                [ 'position', index ],
                [ 'font-size', this.getTemplateData.productSectionsStyles.meta.fontSize ]
            ])
			color = 'rgb('
			color += (this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.cartButton.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.cartButton.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.cartButton.color.defaultColor]
			color += ')'
			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.cartButton.backgroundColor.value])
				? this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.cartButton.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.cartButton.backgroundColor.defaultColor]
			backgroundColor += ')'
			index++
            style.push([ '.button.action, .range .dot.selected, .range .selected div',
                [ 'position', index ],
                [ 'color', color, 1 ],
				[ 'background-color', backgroundColor, 1 ]
            ])
			color = 'rgb('
			color += (this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.detailsButton.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.detailsButton.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.productSectionsStyles.detailsButton.color.defaultColor]
			color += ')'
			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.detailsButton.backgroundColor.value])
				? this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.detailsButton.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.productSectionsStyles.detailsButton.backgroundColor.defaultColor]
			backgroundColor += ')'
			index++
            style.push([ '.button.primary',
                [ 'position', index ],
				[ 'color', color ],
				[ 'background-color', backgroundColor ]
            ])
			index++
			color = 'rgb('
			color += (this.getColorSchemeFontColors[this.getTemplateData.siteOptions.footer.color.value] != null)
				? this.getColorSchemeFontColors[this.getTemplateData.siteOptions.footer.color.value]
				: this.getColorSchemeFontColors[this.getTemplateData.siteOptions.footer.color.defaultColor]
			color += ')'
			backgroundColor = 'rgb('
			backgroundColor += (this.getColorSchemeColors[this.getTemplateData.siteOptions.footer.backgroundColor.value])
				? this.getColorSchemeColors[this.getTemplateData.siteOptions.footer.backgroundColor.value]
				: this.getColorSchemeColors[this.getTemplateData.siteOptions.footer.backgroundColor.defaultColor]
			backgroundColor += ')'
			style.push([ 'footer',
				[ 'position', index ],
				[ 'background-color', backgroundColor ],
				[ 'color', color ]
			])
			index++
			style.push([ 'footer *',
				[ 'position', index ],
				[ 'color', color ]
			])
			this.addStylesheetRules({ parent: '#website-preview', rules: style })
		},
		toggleAccordion(accordion) {
			if (this.selectedAccordion == accordion) {
				this.selectedAccordion = null
			} else {
				this.selectedAccordion = accordion
			}
		},
		toggleViewport(device) {
			if (device == this.selectedDevice && device != 'desktop') {
				this.landscapeMode = !this.landscapeMode
			} else {
				this.selectedDevice = device
			}
		},
		selectSection(section, index) {
			switch(section) {
				case 'header':
				case 'nav':
				case 'footer':
				case 'meta':
					this.selectedSection = section;
					break;
				case 'none':
					this.selectedSection = null;
				default:
					this.selectedSection = index;
					break;

				//console.log(this.selectedSection)
			}
		},
		fontFamilySelected(index) {
			if (this.getTemplateData.siteOptions.highlightFont) {
				return index == this.getTemplateData.siteOptions.highlightFont
			} else {
				return null
			}
		},
		resetTemplateColors() {
			this.getTemplateData.siteOptions.backgroundColor.value = this.getTemplateData.headerOptions.backgroundColor.value = null
		},
		startDrag(evt) {
			// console.log(evt)
			this.drag = evt.oldIndex + 1
		},
		cloneSection(section) {
			return this.$copy(section)
		},
		endDrag(evt) {
			// this.pageSections[evt.added.newIndex].hash = [...Array(32)].map(i=>(~~(Math.random()*36)).toString(36)).join('')
			this.drag = false
			// console.log(this.pageSections[evt.added.newIndex])
			this.saveTemplateData(this.template_id)
			this.siteOptionsStyle()
		},
		removeSection(index) {
			this.pageSections.splice(index, 1)
			this.saveTemplateData(this.template_id)
		},
		selectHeaderLayout(layout) {

		},
		logoUploadSuccess(file, response) {
			var response = JSON.parse(response)
            // TODO: is this redundant with store.js?
			// if (response.status == 'login_required') {
			// 	this.$store.commit('UPDATE_LOGIN_REQUIRED', true)
	        // 	var location = '/login?return=' + encodeURI(document.location.pathname + document.location.search)
        	// 	document.location.replace(location)
			// }
			// this.updateSiteLogo(response.image)
			this.updateTemplateData({ path: 'headerOptions.logo', value: response.image})
			this.$refs.logoDropzone.removeAllFiles()
		},
		headerBackgroundUploadSuccess(file, response) {
			var response = JSON.parse(response)
            // TODO: is this redundant with store.js?
			// if (response.status == 'login_required') {
			// 	this.$store.commit('UPDATE_LOGIN_REQUIRED', true)
	        // 	var location = '/login?return=' + encodeURI(document.location.pathname + document.location.search)
        	// 	document.location.replace(location)
			// }
			this.updateTemplateData({ path: 'headerOptions.backgroundImage', value: response.image })
			this.$refs.headerBackgroundDropzone.removeAllFiles()
			this.setHeaderBackgroundImageMeta()
            this.siteOptionsStyle()
		},
		siteBackgroundUploadSuccess(file, response) {
			response = JSON.parse(response)
            // TODO: is this redundant with store.js?
			// if (response.status == 'login_required') {
			// 	this.$store.commit('UPDATE_LOGIN_REQUIRED', true)
	        // 	var location = '/login?return=' + encodeURI(document.location.pathname + document.location.search)
        	// 	document.location.replace(location)
			// }
			this.updateTemplateData({ path: 'siteOptions.backgroundImage', value: response.image })
			// this.updateSiteBackground(response.image)
			this.$refs.siteBackgroundDropzone.removeAllFiles()
			this.setBackgroundImageMeta()
		},
		siteBackgroundUploadError(file, message, xhr) {
			console.log('siteBackgroundUploadError')
			console.log(file)
			console.log(message)
			console.log(xhr)
		},
		setHeaderMeta() {
			this.headerWidth = this.$refs.header.clientWidth
			this.headerHeight = this.$refs.header.clientHeight
		},
		setBackgroundImageMeta() {
			if (!this.getTemplateData.siteOptions || !this.getTemplateData.siteOptions.backgroundImage) {
				return
			}
		    var img = new Image()
		    var meta
		    var _this = this
		    img.onload = function() {
				_this.backgroundImageWidth = this.width
		    	_this.backgroundImageHeight = this.height
		    }
		    img.src = this.getTemplateData.siteOptions.backgroundImage
		},
		setHeaderBackgroundImageMeta() {
			setTimeout(() => {
				if (!this.getHeaderOptions.backgroundImage) {
					return
				}
			    var img = new Image()
			    var meta
			    var _this = this
			    img.onload = function() {
					_this.headerBackgroundImageWidth = this.width
			    	_this.headerBackgroundImageHeight = this.height
			    }
			    img.src = this.getHeaderOptions.backgroundImage
			}, 1000)
		},
		publish() {
			this.publishing = true
			this.saveTemplateData(this.template_id).then(obj => {
				this.apiCall({ destination: 'save_item_template_publish', data: { template_id: this.template_id }}).then(obj => {
					console.log(obj)
					this.publishing = false
					this.publishSuccess = true
					setTimeout(() => {
						this.publishSuccess = false
					}, 3000)
				}).catch(err => {
					this.publishing = false
					console.log(err)
				})
			}).catch(err => {
				this.publishing = false
				console.log(err)
			})
		}
	}
}
</script>


<style lang="scss" scoped>
.popup-wrapper {
	top: -2em;
	right: 1em;
}
</style>